import { Component, OnInit, ViewChild } from '@angular/core';
import { BaseCrudComponent } from '@app/admin/base-crud.component';
import { AlertService, DatasourceService, AuthService } from '@app/core/services';
import { State } from '@progress/kendo-data-query';
import { CreateEditPersonComponent } from '@app/core/windows'; 


@Component({
  selector: 'persons-crud',
  templateUrl: './persons-crud.component.html',
  providers: [ DatasourceService ]
})
export class PersonsCrudComponent extends BaseCrudComponent implements OnInit {

  //Window
  @ViewChild(CreateEditPersonComponent, {static: false}) window !: CreateEditPersonComponent;

  protected menu: string = 'Conceptos';

  protected menuIcon: string = 'gears';
  
  protected label: string = 'Personal autorizado';

  protected name: string = 'Personal autorizado';

  protected table: string = 'persons';
  
  constructor(protected authService: AuthService, protected service : DatasourceService, protected alertService : AlertService) {
    
    super(authService, service, alertService);
    console.log(this.constructor.name);
    this.breadcrumbItems = this.getBreadcumItems();

  }  

  //Overrides
  protected getInitialState() : State {

    let s = this.service.getStateEmpty();
    s.sort = [      
      {field: 'name', dir: 'asc'}
    ];

    return s;

  }

  ngOnInit() { 
    
    super.ngOnInit();    
  
  }

}